import { ReactNode } from 'react';
import { styled } from '@material-ui/core';
import { CustomizedButton } from '@components/Customized';

interface Props {
  error?: boolean;
  buttonAction?: () => void;
  children?: ReactNode;
  disabled?: boolean;
}

export default function BubbleButton({
  disabled = false,
  children,
  buttonAction,
  error
}: Props) {
  return (
    <Wrapper>
      <CustomizedButton
        color={error ? 'error' : 'primary'}
        disabled={disabled}
        variant="contained"
        fullWidth
        onClick={buttonAction}
      >
        <i
          className={
            children === '제조현황 확인'
              ? 'request-gtm-manufactureCheck-btn'
              : ''
          }
        >
          {children}
        </i>
      </CustomizedButton>
    </Wrapper>
  );
}

const Wrapper = styled('div')(() => ({
  padding: '16px 16px 0px 16px'
}));
